var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 24,
    viewBox: "0 0 40 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo=Mastercard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.2446 5.61133H16.7549V17.4606H23.2446V5.61133Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.1674 11.5358C17.1664 10.3946 17.4209 9.26818 17.9117 8.24172C18.4025 7.21527 19.1166 6.31571 20.0002 5.61116C18.9061 4.73735 17.592 4.19394 16.2083 4.04304C14.8246 3.89214 13.427 4.13984 12.1753 4.75783C10.9236 5.37582 9.86822 6.33916 9.12988 7.53775C8.39154 8.73634 8 10.1218 8 11.5358C8 12.9498 8.39154 14.3353 9.12988 15.5339C9.86822 16.7325 10.9236 17.6958 12.1753 18.3138C13.427 18.9318 14.8246 19.1795 16.2083 19.0286C17.592 18.8777 18.9061 18.3343 20.0002 17.4605C19.1167 16.7559 18.4025 15.8563 17.9117 14.8299C17.4209 13.8034 17.1664 12.677 17.1674 11.5358Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M31.9998 11.5358C31.9999 12.9498 31.6084 14.3352 30.8701 15.5338C30.1318 16.7324 29.0765 17.6958 27.8248 18.3138C26.5731 18.9318 25.1755 19.1795 23.7918 19.0286C22.4081 18.8777 21.0941 18.3343 20 17.4605C20.8828 16.7552 21.5964 15.8555 22.0871 14.8292C22.5778 13.8029 22.8328 12.6768 22.8328 11.5358C22.8328 10.3948 22.5778 9.26871 22.0871 8.24242C21.5964 7.21612 20.8828 6.31642 20 5.61116C21.0941 4.73734 22.4081 4.19393 23.7918 4.04304C25.1755 3.89214 26.5731 4.13985 27.8248 4.75784C29.0765 5.37584 30.1318 6.33919 30.8701 7.53778C31.6084 8.73636 31.9999 10.1218 31.9998 11.5358Z",
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M31.2925 16.2056V15.963H31.3887V15.9136H31.1436V15.963H31.2399V16.2056H31.2925ZM31.7685 16.2056V15.9131H31.6933L31.6069 16.1143L31.5204 15.9131H31.4452V16.2056H31.4983V15.9849L31.5794 16.1752H31.6344L31.7155 15.9845V16.2056H31.7685Z",
    fill: "#F79E1B"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 23,
    rx: 5.5,
    stroke: "#F4F6F9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardIcon);
export default __webpack_public_path__ + "static/media/mastercard-icon.0372f96b36ff4dc2f6f0eec8db172dec.svg";
export { ForwardRef as ReactComponent };